<template>
  <div>
    <PageHeader title="ลงทะเบียนจ่ายเงินสด" />
    <b-container fluid="xl">
      <div class="py-5 text-font" style="padding-bottom: 100px !important;">
        <b-row>
          <b-col cols="12">
            <h5>
              <strong style="color: black;">
                1. เลือกคอร์ส<hr/>
              </strong>
            </h5>
          </b-col>
          <b-col cols="6">
            <div class="my-4">
              <h6>คอร์ส</h6>
              <b-form-select
                v-model="selected"
                @change="dataCourseInfo()"
                style="position: relative"
                :disabled="isLoading"
              >
                <option value="null">เลือกคอร์ส</option>
                <option
                  v-for="(courseListItem, courseListIndex) in courseFilteredList"
                  :key="courseListIndex"
                  :value="courseListIndex"
                >
                  {{ courseListItem.courseName }}
                </option></b-form-select
              >
              <template v-if="isLoading">
                <div
                  class="text-center my-4"
                  style="position: absolute; top: 28px; left: 50%"
                >
                  <b-spinner class="align-middle" variant="primary"></b-spinner>
                </div>
              </template>
            </div>
            <div class="my-3">
              <h6>
                รหัสหลักสูตร : {{ courseCode }}
              </h6>
            </div>
            <div class="my-3">
              <h6>
                ราคา : {{ formatPrice(coursePrice) }}
              </h6>
            </div>
            <div class="my-3">
              <h6>
                ผู้สอน : {{ courseOwner }}
              </h6>
            </div>
            <div class="my-3">
              <h6>
                ระยะเวลาเรียน : {{ learnDuration }}
              </h6>
            </div>
            <div class="my-3">
              <h6>
                ชั่วโมงเรียน : {{ learnTimeLimit }}
              </h6>
            </div>
          </b-col>
          <template v-if="isWannasorn">
            <b-col cols="6">
              <div class="my-4">
                <h6>รูปแบบคอร์ส</h6> 
                <b-form-select
                  v-model="selectedEnrollType"
                  @change="onEnrollTypeChange()"
                  :disabled="isEnrollTypeDisabled"
                >
                  <option
                    v-for="enrollTypeOption in availableEnrollTypes"
                    :key="enrollTypeOption"
                    :value="enrollTypeOption"
                  >
                    {{ enrollTypeLabels[enrollTypeOption] }}
                  </option>
                </b-form-select>
              </div>
              <img
                :src="imagePreview"
                class="img-fluid d-block mx-auto"
                style="max-height: 320px; width: auto; object-fit: contain;"
              />
            </b-col>
          </template>
          <template v-else>
            <b-col cols="6">
              <img
                :src="imagePreview"
                class="img-fluid d-block mx-auto"
                style="max-height: 320px; width: auto; object-fit: contain;"
              />
            </b-col>
          </template>
          <b-col cols="12">
            <b-button
              variant="outline-primary"
              @click="addPurchaseCourse()"
              :disabled="!coursePrice || isAddBlocked"
              >เพิ่มในรายการสั่งซื้อ
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col cols="12">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <strong style="color: black;">2. ตรวจสอบคำสั่งซื้อ</strong>
              </h5>
              <b-form-checkbox
                v-model="noPayment"
                switch
                @change="onToggleNoPayment"
              >
                ไม่มีการชำระเงิน
              </b-form-checkbox>
            </div>
            <hr/>
          </b-col>
          <b-col cols="12" v-if="!selectedCourse || selectedCourse.length === 0">
            <div class="no-selected-course">
                <h5>ไม่มีคำสั่งซื้อ</h5>
            </div>
          </b-col>
          <b-col cols="12" v-else>
            <template>
              <div v-for="course in selectedCourse" :key="course.courseId" class="selected-course">
                <b-row style="margin: 0 !important; height: 100%;">
                  <b-col cols="2">
                    <b-row>
                      <img :src="course.courseThumbnail" class="img-fluid" style="height: 80px; width: 140px;"/>
                    </b-row>
                    <b-row style="margin-top: 10px; display: flex; width: 140px;">
                        <div>
                          <h6>ราคา</h6>
                        </div>
                        <div style="margin-left: auto;">
                          <h6>
                            <strong class="text-primary">
                              {{ formatPrice(course.coursePrice) }}
                            </strong>
                          </h6>
                        </div>
                    </b-row>
                  </b-col>
                  <b-col cols="8">
                    <h6 style="color: black;"> <strong> {{ course.courseName }} </strong> </h6>
                    <h6 style="margin: 5px 0px;"> {{ course.courseCode }} </h6>
                    <h6 style="margin: 10px 0px; color: #777777;"> {{ course.courseOwnerName }}</h6>
                    <h6> {{ getLearingDuration(course) }} </h6>
                    <span
                      class="enroll-type-badge"
                      :class="course.enrollType === 'ONSITE' ? 'enroll-type-onsite' : 'enroll-type-online'"
                    >
                      <b-icon
                        :icon="course.enrollType === 'ONSITE' ? 'easel' : 'display'"
                        class="mr-1"
                        font-scale="1.1"
                      ></b-icon>
                      {{ course.enrollType === 'ONSITE' ? 'รอบสด' : 'ออนไลน์' }}
                    </span>
                  </b-col>
                  <b-col cols="2">
                    <div class="d-flex align-items-center" style="height: 100%;">
                      <b-button
                        class="mx-2"
                        variant="outline-warning"
                        @click="openModal(course)"
                        >แก้ไข
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        @click="removePurchaseCourse(course.courseId, course.enrollType)"
                        >ลบ
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col cols="12">
            <h5>
              <strong style="color: black;">3. กรอกข้อมูลผู้เรียนเพื่อลงทะเบียน<hr/></strong>
            </h5>
          </b-col>
          <b-col cols="12">
            <div>
              <b-form-radio-group
                v-model="memberType"
                :options="memberTypeOptions"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
            </div>
          </b-col>
          <template v-if="memberType == 'newMember'">
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label-for="email"
                  :state="emailTouched ? emailState : null"
                  invalid-feedback="กรุณากรอกอีเมล / อีเมลนี้ถูกใช้งานแล้ว กรุณาตรวจสอบและกรอกอีกครั้ง"
                >
                  <template #label>
                    อีเมล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="email"
                    v-model="registerForm.email"
                    placeholder="example@mail.com"
                    type="email"
                    :state="emailTouched ? emailState : null"
                    @keyup="emailTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4" class="mt-3">
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label-for="password"
                  :state="passwordTouched ? passwordState : null"
                  invalid-feedback="รหัสผ่านต้องมีความยาว 5 - 13 ตัวอักษร"
                >
                  <template #label>
                    รหัสผ่าน <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="password"
                    v-model="registerForm.password"
                    placeholder="รหัสผ่านอย่างน้อย 5 หลัก"
                    type="password"
                    :state="passwordTouched ? passwordState : null"
                    @keyup="passwordTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label-for="confirmPassword"
                  :state="confirmPasswordTouched ? confirmPasswordState : null"
                  invalid-feedback="ยืนยันรหัสผ่านต้องเหมือนกันรหัสผ่าน"
                >
                  <template #label>
                    ยืนยันรหัสผ่าน <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="confirmPassword"
                    v-model="registerForm.confirmPassword"
                    placeholder="กรอกรหัสผ่านอีกครั้ง"
                    type="password"
                    :state="confirmPasswordTouched ? confirmPasswordState : null"
                    @keyup="confirmPasswordTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label="ชื่อ"
                  label-for="firstName"
                  :state="firstNameTouched ? firstNameState : null"
                  invalid-feedback="กรุณากรอกชื่อ"
                >
                  <template #label>
                    ชื่อ <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="firstName"
                    v-model="registerForm.firstName"
                    placeholder="ชื่อ"
                    :state="firstNameTouched ? firstNameState : null"
                    @keyup="firstNameTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label="นามสกุล"
                  label-for="lastName"
                  :state="lastNameTouched ? lastNameState : null"
                  invalid-feedback="กรุณากรอกนามสกุล"
                >
                  <template #label>
                    นามสกุล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="lastName"
                    v-model="registerForm.lastName"
                    placeholder="นามสกุล"
                    :state="lastNameTouched ? lastNameState : null"
                    @keyup="lastNameTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  label="เลขบัตรประชาชน"
                  label-for="school"
                  :state="idCardState"
                  invalid-feedback="เลขบัตรประชาชนไม่ถูกต้อง"
                >
                  <b-form-input
                    id="idCard"
                    v-model="registerForm.idCard"
                    placeholder="บัตรประชาชน"
                    :state="idCardState"
                    @input="onIdCardInput"
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  label="โรงเรียน/สถานศึกษา"
                  label-for="school"
                >
                  <b-form-input
                    id="school"
                    v-model="registerForm.school"
                    placeholder="โรงเรียนหรือสถานศึกษา"
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label-for="phone"
                  :state="phoneTouched ? phoneState : null"
                  invalid-feedback="กรุณากรอกเบอร์โทรศัพท์"
                >
                  <template #label>
                    เบอร์โทร <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="phone"
                    v-model="registerForm.phone"
                    placeholder="0999999999"
                    type="tel"
                    inputmode="numeric"
                    maxlength="15"
                    :formatter="numberOnly"
                    :state="phoneTouched ? phoneState : null"
                    @keyup="phoneTouched = true"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="8" class="mt-3">
              <div>
                <b-form-group
                  label="ที่อยู่"
                  label-for="address"
                >
                  <b-form-input
                    id="address"
                    v-model="registerForm.address"
                    placeholder="ที่อยู่ผู้เรียน"
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="8" class="mt-3">
              <div>
                <b-form-group
                  label="หมายเหตุ"
                  label-for="remark"
                >
                  <b-form-input
                    id="remark"
                    v-model="registerForm.remark"
                    placeholder="ระบุหมายเหตุ"
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="8" class="mt-3" v-if="!noPayment">
              <div>
                <b-form-group
                  label="แนบสลิปการโอนเงิน"
                  label-for="slipFileInput"
                >
                  <div>
                    <input
                      id="slipFileInput"
                      :key="slipImageKey"
                      type="file"
                      accept="jpg,png,pdf"
                      @change="updateSlipImage"
                    >
                  </div>
                  <span style="font-size: x-small;">(ไฟล์ .jpg, .png หรือ .pdf)</span>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
          </template>
          <template v-else-if="memberType == 'oldMember'">
            <b-col cols="4" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label-for="email"
                  :state="enrollEmailTouched ? enrollEmailState : null"
                  invalid-feedback="ไม่พบอีเมลนี้ กรุณาตรวจสอบและกรอกอีเมลอีกครั้ง"
                >
                  <template #label>
                    อีเมล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="email"
                    v-model="enrollForm.email"
                    placeholder="example@mail.com"
                    type="email"
                    :state="enrollEmailTouched ? enrollEmailState : null"
                    @keyup="checkEmail"
                    required
                  />
                  <template #invalid-feedback>
                    <div v-if="!enrollForm.email">กรุณากรอกอีเมล</div>
                    <div v-else-if="!isEmailFormatValid">รูปแบบอีเมลไม่ถูกต้อง</div>
                  </template>
                  <div class="invalid-feedback d-block" v-if="memberEmailNotfound">
                    ไม่พบอีเมลนี้ กรุณาตรวจสอบอีกครั้ง
                  </div>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4">
              <b-button
                style="margin-top: 47px;"
                variant="outline-primary"
                @click="getMemberInfo()"
                :disabled="!enrollForm.email"
                >ตรวจสอบอีเมล
              </b-button>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="1" class="mt-2">
              ชื่อ
            </b-col>
            <b-col cols="11" class="mt-2">
              {{ enrollForm.name }}
            </b-col>
            <b-col cols="1">
              เบอร์โทร
            </b-col>
            <b-col cols="11">
              {{ enrollForm.phone }}
            </b-col>
            <b-col cols="8" class="mt-3">
              <div>
                <b-form-group
                  label="หมายเหตุ"
                  label-for="enrollFormRemark"
                >
                  <b-form-input
                    id="enrollFormRemark"
                    v-model="enrollForm.remark"
                    placeholder="ระบุหมายเหตุ"
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="8" class="mt-3" v-if="!noPayment">
              <div>
                <b-form-group
                  label="แนบสลิปการโอนเงิน"
                  label-for="slipFileInput"
                >
                  <div>
                    <input
                      id="slipFileInput"
                      :key="slipImageKey"
                      type="file"
                      accept="jpg,png,pdf"
                      @change="updateSlipImage"
                    >
                  </div>
                  <span style="font-size: x-small;">(ไฟล์ .jpg, .png หรือ .pdf)</span>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4"></b-col>
          </template>
        </b-row>
        <b-row class="mt-5" v-if="isWannasorn && cartHasBookEligible">
          <b-col cols="12">
            <h5>
              <strong style="color: black;">4. การรับ/จัดส่ง บัตรนักเรียน/ใบเสร็จ/หนังสือเรียน<hr/></strong>
            </h5>
          </b-col>
          <!-- ONSITE course -->
          <b-col cols="12" class="mb-3" v-if="cartHasOnsiteBook">
            <h6>สถานที่รับ สำหรับคอร์สเรียนสด</h6>
            <b-form-select :value="'พญาไท'" disabled>
              <option value="พญาไท">รับที่สาขาพญาไท</option>
            </b-form-select>
          </b-col>
          <!-- ONLINE course -->
          <template v-if="cartHasOnlineBook">
          <b-col cols="12" class="mb-2">
            <h6>
              เลือกสถานที่รับ/จัดส่ง สำหรับคอร์สออนไลน์ <span class="text-danger">*</span>
            </h6>
            <b-form-select v-model="onlineDeliveryMethod">
              <option :value="null" disabled>โปรดเลือกสถานที่</option>
              <option
                v-for="branch in pickupBranchOptions"
                :key="branch.value"
                :value="branch.value"
              >
                รับที่ {{ branch.text }}
              </option>
              <option value="SHIPPING">จัดส่งตามที่อยู่ของนักเรียน (มีค่าจัดส่ง)</option>
            </b-form-select>
          </b-col>
          <template v-if="isShipToAddress">
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label-for="province">
              <template #label>จังหวัด <span class="text-danger">*</span></template>
              <b-form-input
                id="province"
                v-model="shippingAddress.province"
                placeholder="จังหวัด"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label-for="district">
              <template #label>อำเภอ/เขต <span class="text-danger">*</span></template>
              <b-form-input
                id="district"
                v-model="shippingAddress.district"
                placeholder="อำเภอ/เขต"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label-for="subDistrict">
              <template #label>ตำบล/แขวง <span class="text-danger">*</span></template>
              <b-form-input
                id="subDistrict"
                v-model="shippingAddress.subDistrict"
                placeholder="ตำบล/แขวง"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label-for="postcode">
              <template #label>รหัสไปรษณีย์ <span class="text-danger">*</span></template>
              <b-form-input
                id="postcode"
                v-model="shippingAddress.postcode"
                placeholder="รหัสไปรษณีย์"
                maxlength="5"
                inputmode="numeric"
                :formatter="numberOnly"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="หมู่บ้าน/อาคาร" label-for="villageBuilding">
              <b-form-input
                id="villageBuilding"
                v-model="shippingAddress.villageBuilding"
                placeholder="หมู่บ้าน/อาคาร"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="ห้องชุด" label-for="room">
              <b-form-input
                id="room"
                v-model="shippingAddress.room"
                placeholder="ห้องชุด"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label-for="houseNumber">
              <template #label>บ้านเลขที่ <span class="text-danger">*</span></template>
              <b-form-input
                id="houseNumber"
                v-model="shippingAddress.houseNumber"
                placeholder="บ้านเลขที่"
                inputmode="numeric"
                :formatter="houseNumberFormat"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="หมู่" label-for="moo">
              <b-form-input
                id="moo"
                v-model="shippingAddress.moo"
                placeholder="หมู่"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="ซอย" label-for="soi">
              <b-form-input
                id="soi"
                v-model="shippingAddress.soi"
                placeholder="ซอย"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="ถนน" label-for="street">
              <b-form-input
                id="street"
                v-model="shippingAddress.street"
                placeholder="ถนน"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-3">
            <b-form-group class="mb-0" label="เบอร์ติดต่อ" label-for="shippingPhone">
              <b-form-input
                id="shippingPhone"
                v-model="shippingAddress.phone"
                placeholder="เบอร์ติดต่อ"
                type="tel"
                inputmode="numeric"
                maxlength="15"
                :formatter="numberOnly"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mt-2">
            <small
              v-if="shippingAddressAnyFilled && !shippingAddressRequiredFilled"
              class="text-danger"
            >
              กรุณากรอกที่อยู่ให้ครบ (จังหวัด, อำเภอ/เขต, ตำบล/แขวง, รหัสไปรษณีย์, บ้านเลขที่)
            </small>
          </b-col>
          </template>
          </template>
        </b-row>
      </div>
    </b-container>
    <footer
      class="bottom-toolbar border-top fixed-bottom"
      :class="{ 'sidebar-left-hidden': !sidebarOpened }"
    >
      <b-container fluid="xl">
        <b-row class="align-items-center py-3 flex-nowrap">
          <b-col class="summary-text">
            <span class="text-nowrap">ลงทะเบียน {{ selectedCourse.length }} คอร์ส</span>
            <span class="mx-2">|</span>
            <strong class="text-primary text-nowrap">ยอดรวม {{ grandTotalFormatted }} บาท</strong>
            <small v-if="shippingFee > 0" class="text-muted ml-2 text-nowrap">
              (รวมค่าจัดส่งหนังสือแล้ว {{ formatPrice(shippingFee) }} บาท)
            </small>
          </b-col>
          <b-col cols="auto" class="text-right">
            <b-button
              variant="primary"
              @click="submitRegisterCash()"
              :disabled="isSubmitDisabled"
              >ยืนยันการลงทะเบียน <b-spinner v-if="isRegisterLoading" small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </footer>
    <template>
      <b-modal 
        id="editCourseData" 
        :title="modalEditing.courseName || 'course title'" 
        centered
        hide-footer
        size="lg"
      >
        <div v-if="modalEditing" style="margin: 20px;">
          <b-row class="mt-3">
            <b-col cols="3">
              <img :src="modalEditing.courseThumbnail" class="img-fluid" style="height: 80px; width: 140px;"/>
            </b-col>
            <b-col cols="9">
              <h6 style="color: black;"> <strong> {{ modalEditing.courseName }} </strong> </h6>
              <h6 style="margin: 5px 0px;"> {{ modalEditing.courseCode }} </h6>
              <h6 style="margin: 10px 0px; color: #777777;"> {{ modalEditing.courseOwnerName }}</h6>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="6" class="mt-3">
              <div>
                <b-form-group
                  label="ราคา"
                  label-for="modalCoursePrice"
                >
                  <b-form-input
                    id="modalCoursePrice"
                    v-model="modalEditing.coursePrice"
                    type="number"
                    min="0"
                    :disabled="noPayment"
                    @keyup="resetPrice"
                    @keypress="blockNegative"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="6" class="mt-3">
              <div>
                <b-form-group
                  class="mb-0"
                  label="ระยะเวลาเรียน"
                  label-for="modalCourseLearnDuration"
                  :state="modalLearnDurationTouched ? modalLearnDurationState : null"
                  invalid-feedback="กรุณากรอกระยะเวลาเรียน"
                >
                  <b-form-input
                    id="modalCourseLearnDuration"
                    v-model="modalEditing.courseLearnDuration"
                    :state="modalLearnDurationTouched ? modalLearnDurationState : null"
                    min="1"
                    @keyup="modalLearnDurationTouched = true"
                    @keypress="blockNegative"
                    required
                  />
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Status">
                <b-form-select
                  v-model="modalEditing.courseStartDateType"
                  :options="courseStartDateTypeOptions"
                  value-field="item"
                  text-field="name"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="text-right mt-3">
          <b-button variant="primary" :disabled="!modalEditing.courseLearnDuration" @click="saveChanges">บันทึก</b-button>
        </div>
      </b-modal>

      <b-modal
        v-model="showEnrollResultModal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
        size="lg"
      >
        <div class="modal-body pa-4">
          <div class="text-center mb-4">
            <h3 class="pt-4">
              <b-icon-check-circle
                v-if="enrollResultData.enrolled.length > 0"
                scale="2.4"
                class="text-success"
              />
              <b-icon-exclamation-circle
                v-else
                scale="2.4"
                class="text-warning"
              />
            </h3>
            <br />
            <h4 style="font-weight: 600;">ผลการลงทะเบียน</h4>
          </div>

          <b-table-simple bordered responsive class="mb-0">
            <b-thead head-variant="light">
              <b-tr>
                <b-th class="text-center" style="width: 180px;">สถานะ</b-th>
                <b-th>ชื่อคอร์ส</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-if="enrollResultData.enrolled.length > 0">
                <b-td class="text-center align-middle">
                  <b-badge variant="success" style="padding: 8px 16px;">
                    <b-icon-check-circle class="mr-1" />สำเร็จ
                  </b-badge>
                </b-td>
                <b-td>
                  <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 0;">
                    <li v-for="course in enrollResultData.enrolled" :key="'enrolled-' + course.courseId">
                      {{ course.courseName }}
                    </li>
                  </ul>
                </b-td>
              </b-tr>
              <b-tr v-if="enrollResultData.skipped.length > 0">
                <b-td class="text-center align-middle">
                  <b-badge variant="danger" style="padding: 8px 16px;">
                    <b-icon-x-circle class="mr-1" />ไม่สำเร็จ
                  </b-badge>
                </b-td>
                <b-td>
                  <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 0;">
                    <li v-for="course in enrollResultData.skipped" :key="'skipped-' + course.courseId">
                      {{ course.courseName }}
                    </li>
                  </ul>
                  <small class="text-danger">* ลงทะเบียนไม่สำเร็จ เนื่องจากลงทะเบียนอยู่แล้ว {{ enrollResultData.skipped.length }} คอร์ส</small>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="modal-footer text-center border-top-0">
          <div>
            <b-button variant="primary" @click="onEnrollResultModalClose">
              เสร็จสิ้น
            </b-button>
          </div>
        </div>
      </b-modal>
    </template>
  </div>
</template>
<script>
import PageHeader from "@/components/layouts/PageHeader.vue";
import { mapActions, mapGetters } from "vuex";
import Numeral from "numeral";
import api from "@/services/api.js";
export default {
  name: "RegisterCash",
  components: {
    PageHeader,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
    sidebarOpened: Boolean,
  },

  data() {
    return {
      imagePreview: "/images/placeholder-image.png",
      selected: null,
      fetchParams: {
        company_id: this.company.id,
      },
      courseOwner: null,
      courseCode: null,
      coursePrice: null,
      learnDuration: null,
      learnTimeLimit: null,
      selectedEnrollType: 'ONLINE',
      enrollTypeLabels: {
        ONLINE: 'คอร์สเรียนออนไลน์',
        ONSITE: 'คอร์สเรียนรอบสอนสด',
      },
      courseFilteredList: [],
      isRegisterLoading: false,
      noPayment: false,
      selectedCourse: [],
      registerForm: {
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        school: '',
        phone: '',
        address: '',
        remark: '',
        idCard: ''
      },
      enrollForm: {
        email: '',
        firstName: '',
        lastName: '',
        name: '',
        phone: '',
        remark: ''
      },
      enrollEmailTouched: false,
      isEmailFormatValid: false,
      isEmailFound: false,
      enrollEmailState: false,
      emailTouched: false,
      passwordTouched: false,
      confirmPasswordTouched: false,
      firstNameTouched: false,
      lastNameTouched: false,
      phoneTouched: false,
      modalLearnDurationTouched: false,
      memberEmailNotfound: false,
      memberType: 'oldMember',
      memberTypeOptions: [
        { item: 'oldMember', name: 'สมาชิกเดิม' },
        { item: 'newMember', name: 'สมาชิกใหม่' },
      ],
      courseStartDateTypeOptions: [
        { item: 'ENROLL', name: 'วันที่ลงทะเบียน'},
        { item: 'START_LEARNING', name: 'วันที่เริ่มเรียน'}
      ],

      // modal
      modalSelectedCourse: null,
      modalEditing: {},

      showEnrollResultModal: false,
      enrollResultData: { enrolled: [], skipped: [], orderId: null },

      slipImageBase64: null,
      slipImageKey: 0,

      onlineDeliveryMethod: null,
      pickupBranchOptions: [
        { text: 'สาขาพญาไท', value: 'พญาไท' },
      ],
      shippingAddress: {
        province: '',
        district: '',
        subDistrict: '',
        postcode: '',
        villageBuilding: '',
        room: '',
        houseNumber: '',
        moo: '',
        soi: '',
        street: '',
        phone: '',
      }
    };
  },

  async mounted() {
    this.fetchParams.company_id = this.company.id;
    if (this.isWannasorn) {
      this.fetchParams.withBook = 1;
    }
    await this.fetchCourseList(this.fetchParams);
    this.courseFilteredList = this.courseList.data.filter(item => item.courseStatus != "SUSPEND" && item.courseStatus != "DELETED" && item.courseStatus != "DISABLED" && item.courseStatus != "DRAFT");
  },
  computed: {
    ...mapGetters("CourseManagement", ["isLoading", "courseList"]),
    emailState() {
      if (!this.registerForm.email) return false;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.registerForm.email);
    },
    passwordState() {
      const password = this.registerForm.password;
      const hasValidLength = password.length >= 5 && password.length <= 13;
      const noThaiOrSpace = /^[\x21-\x7E]+$/.test(password);
      return hasValidLength && noThaiOrSpace;
    },
    confirmPasswordState() {
      const { password, confirmPassword } = this.registerForm;
      return confirmPassword !== '' && confirmPassword === password;
    },
    firstNameState() {
      return this.registerForm.firstName.length > 0;
    },
    lastNameState() {
      return this.registerForm.lastName.length > 0;
    },
    phoneState() {
      const phonePattern = /^[0-9]{9,10}$/;
      return phonePattern.test(this.registerForm.phone);
    },
    idCardState() {
      const idCardPattern = /^[0-9]{13}$/;
      if (this.registerForm.idCard.length > 0) {
        return idCardPattern.test(this.registerForm.idCard);
      } else {
        return null;
      }
    },
    availableEnrollTypes() {
      if (this.selected === null || !this.courseFilteredList[this.selected]) return ['ONLINE'];
      const courseType = this.courseFilteredList[this.selected].courseOnlineType;
      if (courseType === 'ONSITE') return ['ONSITE'];
      if (courseType === 'FLEX') return ['ONLINE', 'ONSITE'];
      // ONLINE and any legacy/unknown type (e.g. HYBRID) → online only
      return ['ONLINE'];
    },
    isEnrollTypeDisabled() {
      if (this.isLoading || this.selected === null) return true;
      return this.availableEnrollTypes.length <= 1;
    },
    isAlreadySelected() {
      if (this.selected === null || !this.courseFilteredList[this.selected]) return false;
      // Block the same course (any enroll type) from being added twice.
      return this.selectedCourse.some(
        course => course.courseId === this.courseFilteredList[this.selected].courseId
      );
    },
    // The order is limited to a single course type; an order's type is the type
    // of whatever is already in the cart (null when the cart is empty).
    cartEnrollType() {
      return this.selectedCourse.length > 0 ? this.selectedCourse[0].enrollType : null;
    },
    // "Add to order" gating:
    //   - empty cart        → any single course may start the order
    //   - onsite order      → capped at exactly 1 course (nothing more can be added)
    //   - online order      → only more (distinct) online courses may be added
    isAddBlocked() {
      if (this.selected === null || !this.courseFilteredList[this.selected]) return true;
      if (this.selectedCourse.length === 0) return false;
      if (this.cartEnrollType === 'ONSITE') return true;
      if (this.selectedEnrollType === 'ONSITE') return true;
      return this.isAlreadySelected;
    },
    modalLearnDurationState() {
      return this.modalEditing.courseLearnDuration > 0;
    },
    isWannasorn() {
      return [
        1000001, // chemou
        1000002, // appliedphysics
        1000003, // biobeam
      ].includes(this.$store.state.Company.companyInfo.id);
    },
    isShipToAddress() {
      return this.onlineDeliveryMethod === 'SHIPPING';
    },
    shippingFee() {
      return this.isShipToAddress ? 100 : 0;
    },
    courseTotalRaw() {
      if (!this.selectedCourse || this.selectedCourse.length <= 0) return 0;
      return this.selectedCourse.reduce((sum, course) => sum + Number(course.coursePrice), 0);
    },
    grandTotalFormatted() {
      return Numeral(this.courseTotalRaw + this.shippingFee).format('0,0.00');
    },
    // Online book courses follow the admin's pickup/shipping choice.
    onlineBookCourses() {
      return this.selectedCourse.filter(
        course => this.isBookEligible(course) && course.enrollType !== 'ONSITE'
      );
    },
    // Onsite book courses are always picked up at Phaya Thai (no choice).
    onsiteBookCourses() {
      return this.selectedCourse.filter(
        course => this.isBookEligible(course) && course.enrollType === 'ONSITE'
      );
    },
    cartHasOnlineBook() {
      return this.onlineBookCourses.length > 0;
    },
    cartHasOnsiteBook() {
      return this.onsiteBookCourses.length > 0;
    },
    cartHasBookEligible() {
      return this.cartHasOnlineBook || this.cartHasOnsiteBook;
    },
    shippingAddressAnyFilled() {
      return Object.values(this.shippingAddress).some(
        value => value !== '' && value !== null
      );
    },
    shippingAddressRequiredFilled() {
      const address = this.shippingAddress;
      return !!(
        address.province &&
        address.district &&
        address.subDistrict &&
        address.postcode &&
        address.houseNumber
      );
    },
    isSubmitDisabled() {
      if (this.selectedCourse.length <= 0 || this.isRegisterLoading) return true;
      // An online book course requires an explicit pickup/shipping choice.
      if (this.cartHasOnlineBook && !this.onlineDeliveryMethod) return true;
      if (this.isShipToAddress && !this.shippingAddressRequiredFilled) return true;
      if (this.memberType === 'newMember') {
        return !(
          this.emailState &&
          this.firstNameState &&
          this.lastNameState &&
          this.phoneState &&
          this.passwordState &&
          this.confirmPasswordState
        );
      }
      return !this.enrollForm.name;
    },
  },
  watch: {
    cartHasOnlineBook(hasOnlineBook) {
      if (!hasOnlineBook) {
        this.onlineDeliveryMethod = null;
        this.shippingAddress = {
          province: '',
          district: '',
          subDistrict: '',
          postcode: '',
          villageBuilding: '',
          room: '',
          houseNumber: '',
          moo: '',
          soi: '',
          street: '',
          phone: '',
        };
      }
    },
  },
  methods: {
    ...mapActions("CourseManagement", ["fetchCourseList"]),

    editPrice(value) {
      var newValue = value.replace(/[^0-9]|e/g, "");
      if (isNaN(Number(newValue))) {
        return newValue;
      } else {
        return Numeral(Number(newValue)).format('0,0.00');
      }
    },
    addPurchaseCourse() {
      this.selectedCourse.push(this.prepareData(this.courseFilteredList[this.selected]))
    },
    removePurchaseCourse(courseId, enrollType){
      this.selectedCourse = this.selectedCourse.filter(
        course => !(course.courseId === courseId && course.enrollType === enrollType)
      );
    },
    formatPrice(price){
      return price === "0" ? "ฟรี" : Numeral(Number(price)).format('0,0.00');
    },
    checkCoursePrice(course, enrollType = this.selectedEnrollType){
      // For onsite enrollment the price lives in onsiteCourse (osc_price/osc_promotionPrice).
      if (enrollType === 'ONSITE') {
        const onsite = course.onsiteCourse;
        if (!onsite || Array.isArray(onsite)) return 0;
        if (onsite.promotionPrice !== null && onsite.promotionPrice !== undefined) {
          return onsite.promotionPrice;
        }
        return onsite.price === "0.00" || onsite.price == null ? 0 : onsite.price;
      }
      if (course.seasonPrice.price !== null && course.seasonPrice.enable == true) {
        return Numeral(Number(course.seasonPrice.price)).format("0.00");
      } else if (course.promotionPrice !== null) {
        return course.promotionPrice;
      } else {
        return course.price === "0.00" || course.price == null ? 0 : course.price;
      }
    },
    checkCourseStartDateType(course){
      if (course.seasonPrice.enable == true && course.seasonPrice.startDateType !== null) return course.seasonPrice.startDateType
      else return 'ENROLL'
    },
    getLearingDuration(course) {
      let learnDuration = course.courseLearnDuration
        ? course.courseLearnDuration + " วัน"
        : "ไม่จำกัดวัน";
      let startDateType = (course.courseStartDateType == 'START_LEARNING') ? 'วันที่เข้าเรียน' : 'วันที่ลงทะเบียน'
      return `ระยะเวลาเรียน: ${learnDuration} | เริ่มนับวันเรียน: ${startDateType}`
    },
    dataCourseInfo() {
      // Default the enroll type: an order is limited to a single course type, so
      // prefer the type already in the cart when the course supports it; otherwise
      // fall back to the first available option.
      const cartType = this.cartEnrollType;
      this.selectedEnrollType = (cartType && this.availableEnrollTypes.includes(cartType))
        ? cartType
        : this.availableEnrollTypes[0];

      this.coursePrice = this.checkCoursePrice(this.courseFilteredList[this.selected])

      this.courseCode = this.courseFilteredList[this.selected].courseCode;
      this.courseOwner =
        this.courseFilteredList[this.selected].courseOwner.ownerName;
      this.imagePreview = this.courseFilteredList[this.selected].courseThumbnail;
      this.learnDuration = this.courseFilteredList[this.selected].learnDuration
        ? this.courseFilteredList[this.selected].learnDuration + " วัน"
        : "ไม่จำกัดวัน";
      this.learnTimeLimit = this.courseFilteredList[this.selected].learnTimeLimit
        ? this.courseFilteredList[this.selected].learnTimeLimit + " ชั่วโมง"
        : "ไม่จำกัดชั่วโมง";
    },
    onEnrollTypeChange() {
      // Recompute the displayed price when the format changes (FLEX courses).
      if (this.selected === null) return;
      this.coursePrice = this.checkCoursePrice(this.courseFilteredList[this.selected]);
    },
    openModal(item) {
      this.modalEditing = { ...item }
      if (this.noPayment) {
        this.modalEditing.coursePrice = 0
      }
      this.modalSelectedCourse = item
      this.$bvModal.show('editCourseData')
    },
    async submitRegisterCash() {
      this.isRegisterLoading = true
      var userId = this.$store.state.Authentication.authUser.id;
      const shippingAddress = (this.isShipToAddress && this.shippingAddressRequiredFilled)
        ? { ...this.shippingAddress }
        : null;
      // Attach the per-course fulfilment decision (onsite → forced Phaya Thai pickup,
      // online → admin's choice, free/no-book → null).
      const courses = this.selectedCourse.map(course => ({
        ...course,
        bookDelivery: this.getCourseDelivery(course),
      }));
      let request = {
        adminId: userId,
        course: courses,
        member: (this.memberType == 'oldMember') ? this.enrollForm : this.registerForm,
        slipImage: this.slipImageBase64,
        // Single destination address shared by every online book set to "ship to address".
        shippingAddress,
        // Deprecated order-level pickup (online only) kept for backward compatibility.
        pickupLocation: (this.cartHasOnlineBook && !this.isShipToAddress) ? this.onlineDeliveryMethod : null,
        noPayment: this.noPayment
      };
      await api
        .post(`/v1/confirm-order-cash`, request)
        .then(({ data }) => {
          this.enrollResultData = data.data || { enrolled: [], skipped: [], orderId: null };
          this.showEnrollResultModal = true;
        })
        .catch(({ response }) => {
          this.$bvToast.toast(response.data.message, {
            variant: "danger",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });
          return false;
        });
      this.isRegisterLoading = false
    },
    async getMemberInfo() {
      this.memberEmailNotfound = false
      this.enrollForm.name = '';
      this.enrollForm.phone = '';
      this.enrollForm.firstName = '';
      this.enrollForm.lastName = '';

      await api
        .get(`/v1/companies/${this.company.id}/members?memberEmail=${this.enrollForm.email}`)
        .then(( data ) => {
          const member = data.data.data[0];
          this.enrollForm.name = member.firstName + ' ' + member.lastName;
          this.enrollForm.firstName = member.firstName;
          this.enrollForm.lastName = member.lastName;
          this.enrollForm.phone = member.phoneNumber;
          this.memberEmailNotfound = false
        })
        .catch(() => {
          this.memberEmailNotfound = true
        });
    },
    prepareData(courseInfo) {
      const originalPrice = this.checkCoursePrice(courseInfo);
      const tempCourse = {
        courseId : courseInfo.courseId,
        courseCode: courseInfo.courseCode,
        courseName:courseInfo.courseName,
        coursePrice: this.noPayment ? 0 : originalPrice,
        originalPrice: originalPrice,
        courseThumbnail: courseInfo.courseThumbnail,
        courseOwnerName: courseInfo.courseOwner.ownerName,
        courseLearnDuration: courseInfo.learnDuration,
        courseStartDateType: this.checkCourseStartDateType(courseInfo),
        enrollType: this.selectedEnrollType,
        hasBook: !!courseInfo.hasBook,
      };
      return tempCourse;
    },
    onToggleNoPayment(checked) {
      this.selectedCourse.forEach((course) => {
        course.coursePrice = checked ? 0 : course.originalPrice;
      });
      if (checked) {
        this.slipImageBase64 = null;
        this.slipImageKey++;
      }
    },
    resetPrice() {
      if (this.modalEditing.coursePrice === '') {
        this.modalEditing.coursePrice = 0;
      }
    },
    saveChanges() {
      Object.assign(this.modalSelectedCourse, this.modalEditing)
      this.$bvModal.hide('editCourseData')
    },
    checkEmail() {
      this.enrollEmailTouched = true;
      this.memberEmailNotfound = false;

      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailFormatValid = pattern.test(this.enrollForm.email);
      this.enrollEmailState =
        !!this.enrollForm.email && this.isEmailFormatValid;
    },
    blockNegative(event) {
      if (event.key === '-' || event.key === 'e') {
        event.preventDefault();
      }
    },
    numberOnly(value) {
      return value.replace(/[^0-9]/g, '');
    },
    houseNumberFormat(value) {
      return value.replace(/[^0-9/]/g, '');
    },
    // A book is fulfilled (pickup/ship) only for paid courses that include a book.
    // Free courses do not ship books (requirement: "ถ้าฟรี ไม่ต้องมีจัดส่งหนังสือ").
    isBookEligible(course) {
      const price = Number(String(course.coursePrice).replace(/,/g, ''));
      return !!course.hasBook && price > 0;
    },
    // Per-course fulfilment decision:
    //  - onsite book → always pickup at Phaya Thai (forced, no shipping).
    //  - online book → follows the admin's online delivery choice.
    //  - otherwise   → null (nothing to fulfil).
    getCourseDelivery(course) {
      if (!this.isBookEligible(course)) return null;
      if (course.enrollType === 'ONSITE') {
        return { method: 'PICKUP', pickupLocation: 'พญาไท' };
      }
      if (this.onlineDeliveryMethod === 'SHIPPING') {
        return { method: 'SHIPPING', pickupLocation: null };
      }
      return { method: 'PICKUP', pickupLocation: this.onlineDeliveryMethod || 'พญาไท' };
    },
    onEnrollResultModalClose() {
      this.showEnrollResultModal = false;
      this.enrollResultData = { enrolled: [], skipped: [], orderId: null };
      this.clearData();
    },
    clearData() {
      this.selected = null;
      this.courseCode = null;
      this.courseOwner = null;
      this.coursePrice = null;
      this.learnDuration = null;
      this.learnTimeLimit = null;
      this.selectedEnrollType = 'ONLINE';
      this.imagePreview = "/images/placeholder-image.png";
      this.noPayment = false;
      this.selectedCourse = [];
      this.registerForm = {
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        school: '',
        phone: '',
        address: '',
        remark: '',
        idCard: ''
      };
      this.enrollForm = {
        email: '',
        firstName: '',
        lastName: '',
        name: '',
        phone: '',
        remark: ''
      };

      this.enrollEmailTouched = false;
      this.emailTouched = false;
      this.passwordTouched = false;
      this.confirmPasswordTouched = false;
      this.firstNameTouched = false;
      this.lastNameTouched = false;
      this.phoneTouched = false;
      this.modalLearnDurationTouched = false;
      this.onlineDeliveryMethod = null;
      this.shippingAddress = {
        province: '',
        district: '',
        subDistrict: '',
        postcode: '',
        villageBuilding: '',
        room: '',
        houseNumber: '',
        moo: '',
        soi: '',
        street: '',
        phone: '',
      };
      this.slipImageKey++
    },
    updateSlipImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = [
        'image/jpeg',
        'image/png',
        'application/pdf'
      ];

      if (!allowedTypes.includes(file.type)) {
        alert('Invalid file type');
        event.target.value = '';
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        this.slipImageBase64 = reader.result;
      };

      reader.onerror = () => {
        alert('Failed to read file');
      };

      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.selected-course {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  min-height: 147px;
  padding: 20px;
  margin-bottom: 20px;
}

.no-selected-course{
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  height: 147px;
  margin-bottom: 20px;

  color: #777777;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.enroll-type-badge {
  display: inline-flex;
  align-items: center;
  margin-top: 6px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
}

.enroll-type-onsite {
  color: #027bff;
}

.enroll-type-online {
  color: #027bff;
}

.bottom-toolbar {
  padding-left: 250px;
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  z-index: 80;
}

.sidebar-left-hidden {
  padding-left: 0px !important;
}

.bottom-toolbar .summary-text {
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
}
</style>
